import store from "../store";

export default function auth({ next, router, to }) {
  if (!store.getters.isAuthenticated) {
    return router.push({ name: "Login", query: { redirect: to.fullPath } });
  }

  return next();
}
